import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const CitationsSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CitationsTitle = styled.div`
  ${typographyV2.titleMd}
`;

export const DocumentsWrapper = styled.div`
  margin-bottom: 8px;
`;
